import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { buildProviders, KalDialogConfig, KalDialogService, KalSelectionModel } from '@kalidea/kaligraphi';
import uniqBy from 'lodash-es/uniqBy';
import { Observable, of } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import {
    SharedBeneficiaryContactSelectionInformations,
    SharedBeneficiaryContactSelectionList
} from 'src/app/_shared/components/shared-beneficiary-contact-selection/shared-beneficiary-contact-selection-base';
import {
    SharedBeneficiaryListDialogComponent,
    SharedBeneficiaryListDialogData
} from 'src/app/_shared/dialogs/shared-beneficiary-list-dialog/shared-beneficiary-list-dialog.component';
import { arrayEmpty } from 'src/app/utils/array.utils';

@Component({
    selector: 'app-shared-beneficiary-contact-selection',
    templateUrl: './shared-beneficiary-contact-selection.component.html',
    styleUrls: ['./shared-beneficiary-contact-selection.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedBeneficiaryContactSelectionComponent),
    standalone: false
})
export class SharedBeneficiaryContactSelectionComponent extends CustomFormControlAccess implements OnInit {

    @Input() datasource: SharedBeneficiaryContactSelectionList = null;

    @Input() title: string = null;

    @Input({transform: coerceBooleanProperty})
    showMatricules = false;

    constructor(private readonly cdr: ChangeDetectorRef,
                private readonly dialogService: KalDialogService) {
        super();
    }

    writeValue(value: any): void {
        this.datasource.addBeneficiaries(value || []);
        super.writeValue(value);
    }

    validate(c: AbstractControl): Observable<{ [key: string]: boolean }> {
        return of(arrayEmpty(this.selectedBeneficiaryList) ? {invalidbeneficiaryselection: true} : null);
    }

    private get selectedBeneficiaryList(): SharedBeneficiaryContactSelectionInformations[] {
        return this.datasource.beneficiaryList;
    }

    openSelectionBeneficiaryDialog(): void {
        const config = new KalDialogConfig<SharedBeneficiaryListDialogData>({
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-dark-backdrop',
            title: 'Faire un ajout multiple',
            data: {
                selection: new KalSelectionModel({multiple: true}),
                hiddenBeneficiaryIdList: this.selectedBeneficiaryList.map(row => row.Id)
            }
        });

        this.watch$ = this.dialogService.open(SharedBeneficiaryListDialogComponent, config).afterClosed.pipe(
            filter(result => result?.accepted),
            tap(result => {
                const beneficiariesList = result?.selectedBeneficiaries?.map(({ID, NOM, PRENOM, MATRI}) => {
                    return {Id: +ID, Nom: NOM, Prenom: PRENOM, Matricule: MATRI};
                }) || [];

                this.datasource.addBeneficiaries(uniqBy([...(this.selectedBeneficiaryList || []), ...(beneficiariesList || [])], 'Id'));
                this.notifyUpdate(this.selectedBeneficiaryList);
                this.cdr.markForCheck();
            }),
        );
    }

    ngOnInit(): void {
        this.watch$ = this.datasource.beneficiaryList$.pipe(
            tap(e => this.notifyUpdate(e))
        );
    }
}
